import API from '../api-service';
import store from '../../../store/store';
import content from '@/utils/shared/content-structure';

const baseUri = 'licensing';

export default {
  getProducts() {
    return API.get(
      `${baseUri}?clientId=${store.getters.cognitoInfo.clientId}`,
    ).then(res => {
      if (res.content.length > 0) {
        // remove 'Content App' product from list of Products
        res.content = res.content.filter((item) => item.product !== 'SKU-00000296');
      }
      return res.content.map(p => {
        return {
          ...p,
          sku: p.product,
        };
      });
    });
  },
  getContent(sku, params) {
    return API.get(
      `${baseUri}/${store.getters.currentProduct.billingId}/${sku}/content`,
      params,
    ).then(res => {
      return ({
        ots: res.ots.content.map(item => content.mapContent(item)),
        custom: res.custom.content.map(item => content.mapContent(item)),
      });
    });
  },
  getChangesAllowed(sku) {
    return API.get(
      `${baseUri}/${store.getters.currentProduct.billingId}/${sku}/changes/allowed`,
    ).then(res => {
      return res;
    });
  },
  activateContent(sku, contents, type) {
    const body = { codes: contents, type };
    return API.put(
      `${baseUri}/${store.getters.currentProduct.billingId}/${sku}/content`,
      body,
    ).then(res => {
      return ({
        ots: res.ots.content.map(item => content.mapContent(item)),
        custom: res.custom.content.map(item => content.mapContent(item)),
        limit: res.ots.limit,
      });
    });
  },
  deactivateContent(sku, contents, type) {
    const body = { codes: contents, type };
    return API.delete(
      `${baseUri}/${store.getters.currentProduct.billingId}/${sku}/content`,
      body,
    ).then(res => {
      return ({
        ots: res.ots.content.map(item => content.mapContent(item)),
        custom: res.custom.content.map(item => content.mapContent(item)),
        limit: res.ots.limit,
      });
    });
  },
};
